import { render, staticRenderFns } from "./RsaConfigurazioneProfiliLisListComponent.vue?vue&type=template&id=cbdccaa0"
import script from "./RsaConfigurazioneProfiliLisListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneProfiliLisListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports